import { render } from "./App.vue?vue&type=template&id=fd28f9a2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=fd28f9a2&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.16_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__